import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const dndCustomerGroup = 'dean_and_david';
export const customerGroup = dndCustomerGroup;

const supportEmail = {
	dean_and_david: 'dean_and_david@smoothr.de',
};
const firebaseConfig = {
	dean_and_david: {
		apiKey: 'AIzaSyBgQ_LSUpazFB09uhSYSrvdp6A6XVUVQGQ',
		authDomain: 'eam-outlet.firebaseapp.com',
		projectId: 'eam-outlet',
		storageBucket: 'eam-outlet.appspot.com',
		messagingSenderId: '415039699499',
		appId: '1:415039699499:web:05ef1947232f80eef8886e',
		measurementId: 'G-DEM9G228YK',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDAdrZ5vG1_A-5rChcnhh6UQjfhX1OI9QE',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['de'],
	gaId: '',
	hasRecommendations: true,
	apiUrl: 'https://dean-and-david.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: false,
	allowNavigationToWorldline: false,
};
